import { IconDocumentAdd } from '@/components/design/icons';
import { useGaiaToast } from '@/composables/useGaiaToast';
import { useVaultUploadDialog } from '@/composables/useVaultUploadDialog';
import type { FileDropAction } from './types';

/**
 * Create contracts from the dropped files. That is just an upload, into a
 * folder the user picks: every new vault file converts into a contract on its
 * own, in the background.
 */
export const createContractAction: FileDropAction = {
  key: 'create-contract',
  label: 'Create a contract',
  icon: IconDocumentAdd,
  run: async (files, ctx): Promise<void> => {
    ctx.close();
    // The dialog shows progress and errors itself; cancelling uploads nothing.
    const uploaded = await useVaultUploadDialog().openUploadDialog({ files });
    if (!uploaded?.length) return;
    const count =
      uploaded.length === 1 ? uploaded[0].revision.file_name : `${uploaded.length} files`;
    useGaiaToast().success(
      `Uploaded ${count}; turning ${uploaded.length === 1 ? 'it' : 'them'} into ${
        uploaded.length === 1 ? 'a contract' : 'contracts'
      }…`
    );
  },
};
